// A project's stage, as one coloured pill.
//
// One component for the tables and the project page, so a project cannot read
// "Concierge" in one place and "Search" in another — the same rule the alert
// cell follows, and the reason the SQL behind it is a single shared fragment
// (`recruiter/repo/project_stage.py`).
import { Badge } from "@recruiter/shared";

import { stageDisplay } from "../lib/project-stage";

/** `stage` is the OPEN wire union: a newer backend may name a rung this bundle
 *  predates, and an older one may not send the field at all. `stageDisplay`
 *  handles both, so this never renders an empty pill. */
export function ProjectStageBadge({
  stage,
  size = "sm",
}: {
  stage: string | null | undefined;
  size?: "sm" | "md";
}) {
  const display = stageDisplay(stage);
  return (
    <Badge variant={display.variant} tone={display.tone} size={size} title={display.hint}>
      {display.label}
    </Badge>
  );
}
